var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar rounded-circle text-center"},[_vm._v(" "+_vm._s(_vm.userInitials)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }